import React from "react";
import { IDialogChildComponent } from "../../../reducers/dialog";
import { ReactComponent as ShoppingBag } from '../../../assets/images/shopping-bag-3-dots.svg';
import { createStyles, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface IOutstandingCollectionDialogProps extends IDialogChildComponent {

}

const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        margin: "1rem",
        justifyContent: "center",
        alignItems: "center",
        width: "42.5rem",
    },
    title: {
        fontSize: "1.25rem",
        fontWeight: 600
    }
}));

export function OutstandingCollectionDialog(props: IOutstandingCollectionDialogProps) {
    const { t } = useTranslation();
    const { root, title } = useStyles();
    return <div className={root}>
        <div>
            <ShoppingBag />
        </div>
        <div>
            <p className={title}>
                {t('forms.orders.pickup.oustandingTitle')}
            </p>
        </div>
        <div>
            <p>
                {t('forms.orders.pickup.oustandingInfo')}
            </p>
        </div>
    </div>
}